module.exports = __webpack_public_path__ + "static/34-54370a9cee31d007cfbae97f828a859b.jpg";